import React from 'react'
import '../Services/Services.css'
import './About.css'

const AboutHero = () => {
  return (
     <div className="services-hero">
      <div className='about-hero-img'>
      <div className="overlay"></div>
      <div className="hero-content">
        <h2 className='hero_heading'>ABOUT US</h2>
        <p className='hero_subheading'>Innovative strategies, measurable <br/>results </p>
      </div>
    </div>
    </div>
  )
}

export default AboutHero